import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import Paper from 'components/@extended/Paper'
import CompensationChart from 'components/CompensationChart'
import type { FC } from 'react'

interface CompensationChartCardProps {
  title: string
  chartHeight?: number
  customSeries: number[]
  customLabels: string[]
  viewMode?: 'summary' | 'breakdown'
  onViewModeChange?: (mode: 'summary' | 'breakdown') => void
  showToggle?: boolean
}

const CompensationChartCard: FC<CompensationChartCardProps> = ({
  title,
  chartHeight = 380,
  customSeries,
  customLabels,
  viewMode = 'summary',
  onViewModeChange,
  showToggle = false,
}) => {
  // Card height = chart height + header/toggle (~60) + legend space (~50)
  const cardHeight = chartHeight + 110

  return (
    <Paper sx={{ p: 3, height: '100%', minHeight: cardHeight, overflow: 'hidden' }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
        {title}
      </Typography>
      {showToggle && onViewModeChange && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(_, newMode) => newMode && onViewModeChange(newMode)}
            size="small"
          >
            <ToggleButton value="summary" sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}>
              Summary
            </ToggleButton>
            <ToggleButton value="breakdown" sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}>
              Breakdown
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}
      <Box sx={{ width: '100%' }}>
        <CompensationChart customSeries={customSeries} customLabels={customLabels} height={chartHeight} />
      </Box>
    </Paper>
  )
}

export default CompensationChartCard
